import { createSlice } from "@reduxjs/toolkit";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    report: null,
};

export const StudentsByScheduleReport = createSlice({
    name: "StudentsByScheduleReport",
    initialState,
    reducers: {
        setReport: (state, action) => {
            state.report = action.payload;
        },
        clearReport: (state, action) => {
            state.report = initialState.report;
        },
    },
});

export const { setReport, clearReport } = StudentsByScheduleReport.actions;

export default StudentsByScheduleReport.reducer;

//*Actions

export const startGetReport = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const { cycles, coordination_id, exclude_empty } = values;

        const urlParams = new URLSearchParams();

        urlParams.set("cycles", `${cycles.year}-${cycles.sub_cycle}`);
        urlParams.set("export", 0);
        if (coordination_id) {
            urlParams.set("coordination_id", coordination_id);
        }

        const resp = await Call(
            `teachers/v2/school_subjects/schedules/students`,
            "GET",
            urlParams.toString()
        );

        if (resp.success) {
            dispatch(setReport(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startExportReport = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const { cycles, coordination_id, exclude_empty } = values;

        const urlParams = new URLSearchParams();

        urlParams.set("cycles", `${cycles.year}-${cycles.sub_cycle}`);
        urlParams.set("exclude_empty", exclude_empty ? 1 : 0);
        urlParams.set("export", 1);
        if (coordination_id) {
            urlParams.set("coordination_id", coordination_id);
        }

        const response = await CallWithFormDataFile(
            `teachers/v2/school_subjects/schedules/hours`,
            "GET",
            urlParams.toString()
        );
        downloadBlob(response, "Reporte de horas por materia");

        dispatch(stopUILoading());
    };
};
